import { DataColumns } from '../DataColumns/DataColumns';
import { MultiViewCalenderFilterCell } from 'smart-react';
import { GridDateCell, BooleanValuesFilterCell } from '../../../../Core/Components/Filter/FilterElements';
import GridFlag from '../../../../Core/Components/GridFlag/GridFlag';
/**
 * Generates a list of columns for a grid.
 * @param {object} options - The options for the grid.
 * @returns {Array} - The list of grid columns.
 */
export const GridColumnsList = async ({
  editContentSlider,
  handleGenerateQRCode,
  dateRangefilter,
  setDateRangeFilter,
}) => {
  return DataColumns({
    editContentSlider,
    handleGenerateQRCode,
    MultiViewCalenderFilterCell,
    dateRangeFilter: dateRangefilter,
    setDateRangeFilter,
    GridDateCell,
    GridFlag,
    BooleanValuesFilterCell,
  });
};

export default GridColumnsList;
